import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  fetchServiceSettings,
  fetchServiceSettingsData,
  updateServiceSetting,
  fetchEbayStockChangeInfo,
  fetchConditions,
  fetchLocationSettings,
  FetchEbayStockChangeInfoParams,
} from "../api/rest/ebay";

const LONG_LIFE_DATA_STALE_TIME = 5 * 60 * 1000; // ms

export const useFetchServiceSettings = () =>
  useQuery("ebayServiceSettings", fetchServiceSettings);

export const useFetchServiceSettingsData = () =>
  useQuery("ebayServiceSettingsData", fetchServiceSettingsData);

export const useUpdateServiceSetting = () => {
  const queryClient = useQueryClient();
  const { isLoading: isMutating, ...rest } = useMutation(
    (settingData: EbayServiceSettingData) => updateServiceSetting(settingData),
    {
      onSuccess: (
        response: EbayServiceSettingData,
        variables: EbayServiceSettingData
      ) => {
        queryClient.setQueryData<EbayServiceSettingData[]>(
          "ebayServiceSettingsData",
          (prev): EbayServiceSettingData[] => {
            if (prev) {
              return prev.map((serviceSetting) => {
                if (serviceSetting.name === variables.name) {
                  return response;
                }
                return serviceSetting;
              });
            }
            return [variables];
          }
        );
      },
    }
  );
  return { isMutating, ...rest };
};

export const useFetchStockChangeHistory = (
  params: FetchEbayStockChangeInfoParams
) =>
  useQuery(
    ["ebayStockChangeInfo", params],
    () => fetchEbayStockChangeInfo(params),
    { keepPreviousData: true }
  );

export const useFetchConditions = () =>
  useQuery("ebayConditions", fetchConditions, {
    staleTime: LONG_LIFE_DATA_STALE_TIME,
  });

export const useFetchLocationSettings = () =>
  useQuery("ebayLocations", fetchLocationSettings, {
    staleTime: LONG_LIFE_DATA_STALE_TIME,
  });
